import { gql } from "@apollo/client";
import { BundleProductFragment } from "./BundleProductFragment.gql";

export const GET_STORE_CONFIG_DATA = gql`
  query getStoreConfigData {
    storeConfig {
      id
      product_url_suffix
    }
  }
`;

export const GET_PRODUCT_DETAIL_QUERY = gql`
  query getProductDetailForProductPage($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        product_tab_videos {
          url
          thumbnail
        }
        bundle_option_heading
        uid
        __typename
        categories {
          id
          uid
          breadcrumbs {
            category_id
          }
        }
        pdf_url
        enable_site_visit
        enable_appliance_site_visit
        description {
          html
        }
        description_text
        short_description {
          html
        }
        product_highlights
        product_video {
          label
          url
        }
        id
        uid
        type_id
        only_x_left_in_stock
        flag_text
        fitting_instructions
        returns
        warranty_text
        warranty_appliances
        specifications {
          label
          value
        }
        simplebundle
        care_instructions
        media_gallery {
          url
          label
          __typename
        }
        small_image {
          url
        }
        meta_description
        meta_title
        name
        unit_text
        show_enquire_now
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
          maximum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        sku
        small_image {
          url
        }
        stock_status
        url_key
        ... on BundleProduct {
          ...BundleProductFields
        }
        ... on ConfigurableProduct {
          base_variants {
            attributes {
              code
              value_index
            }
            product {
              uid
              sku
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                }
              }
              small_image {
                url
              }
            }
          }
          configurable_options {
            attribute_code
            attribute_id
            id
            label
            values {
              uid
              default_label
              label
              store_label
              use_default_value
              value_index
              swatch_data {
                ... on ImageSwatchData {
                  thumbnail
                }
                value
              }
            }
          }
          variants {
            attributes {
              code
              value_index
            }
            product {
              product_video {
                label
                url
              }
              product_tab_videos {
                url
                thumbnail
              }
              short_description {
                html
              }
              product_highlights
              small_image {
                url
              }
              name
              unit_text
              flag_text
              only_x_left_in_stock
              enable_site_visit
              enable_appliance_site_visit
              description {
                html
              }
              description_text
              care_instructions
              warranty_text
              warranty_appliances
              meta_description
              id
              uid
              __typename
              specifications {
                label
                value
              }
              media_gallery {
                url
                label
                __typename
              }
              sku
              stock_status
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
                maximum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${BundleProductFragment}
`;

export const GET_PRODUCT_UPSELL_PRODUCTS = gql`
  query get($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        upsell_products {
          id
          attribute_set_id
          name
          unit_text
          flag_text
          url_key
          stock_status
          type_id
          enable_site_visit
          enable_appliance_site_visit
          description {
            html
          }
          description_text
          ... on BundleProduct {
            ...BundleProductFields
          }
          short_description {
            html
          }
          product_highlights
          meta_title
          meta_description
          sku
          uid
          simplebundle
          categories {
            name
            url_key
          }
          image {
            url
            label
          }
          small_image {
            url
            label
          }
          media_gallery {
            url
            label
            __typename
          }
          __typename
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              discount {
                amount_off
                percent_off
              }
            }
            maximum_price {
              regular_price {
                value
                currency
              }
              final_price {
                value
                currency
              }
              discount {
                amount_off
                percent_off
              }
            }
          }
        }
      }
    }
  }
  ${BundleProductFragment}
`;

export default {
  getStoreConfigData: GET_STORE_CONFIG_DATA,
  getProductDetailQuery: GET_PRODUCT_DETAIL_QUERY,
};
